(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../button", "../transition", "./error-map", "../_util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../button"), require("../transition"), require("./error-map"), require("../_util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.button, global.transition, global.errorMap, global._util);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _button, _transition, _errorMap, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _button = _interopRequireDefault(_button);
  _transition = _interopRequireDefault(_transition);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-transition', {
        attrs: {
          "name": "nx-empty-self"
        }
      }, [_c('div', {
        staticClass: "nx-empty",
        class: ["nx-empty-" + _vm.type, "nx-empty-" + _vm.size, !_vm.isFullScreen ? 'nx-empty-flex' : ''],
        style: _vm.emptyStyle
      }, [_c('div', {
        class: [!_vm.isFullScreen ? 'nx-empty__wrap__non-full' : 'nx-empty__wrap', _vm.isWebviewFull ? 'nx-empty__wrap-full' : '']
      }, [_c('div', {
        staticClass: "nx-empty__image",
        class: this.type == 'video' ? 'nx-empty__image__novideo' : '',
        on: {
          "click": _vm.$_imgClick
        }
      }, [_c('div', {
        staticClass: "nx-empty__image-content",
        style: _vm.imageStyle
      })]), _vm.$slots.description ? [_vm._t("description")] : _vm._e(), _c('nx-transition', {
        attrs: {
          "appear": "",
          "name": "nx-empty"
        }
      }, [!_vm.$slots.description ? _c('div', {
        staticClass: "nx-empty__desc",
        domProps: {
          "innerHTML": _vm._s(_vm.description || _vm.errorMsg.text)
        }
      }) : _vm._e()]), !_vm.$slots.default ? [_vm.errorMsg && _vm.errorMsg.type !== 'empty' && this.type !== 'unstable' ? _c('div', {
        staticClass: "btn-group"
      }, [_c('nx-button', {
        attrs: {
          "type": "frame-plus"
        },
        on: {
          "click": _vm.$_retry
        }
      }, [_vm._v(_vm._s(_vm.buttonText))])], 1) : _vm._e()] : [_vm._t("default")]], 2)])]);
    },
    name: 'nx-empty',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _button.default.name, _button.default), (0, _defineProperty2.default)(_components, _transition.default.name, _transition.default), _components),
    props: {
      type: {
        type: String
      },
      image: {
        type: String
      },
      description: {
        type: String
      },
      isFullScreen: {
        type: Boolean,
        default: true
      },
      buttonText: {
        type: String,
        default: '重试'
      },
      size: {
        type: String,
        default: 'normal'
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          return _util.isCombineWallet && location.href && location.href.indexOf('sink=1') > -1;
        }
      }
    },
    computed: {
      imageStyle: function imageStyle() {
        var _this$errorMsg, _this$errorMsg2;

        var nxThemeOff = document.documentElement && document.documentElement.getAttribute('data-nx-theme') === 'off';
        var isDarkMode = !nxThemeOff && window.matchMedia('(prefers-color-scheme: dark)').matches;
        var errorImage = isDarkMode ? (_this$errorMsg = this.errorMsg) === null || _this$errorMsg === void 0 ? void 0 : _this$errorMsg.darkImage : (_this$errorMsg2 = this.errorMsg) === null || _this$errorMsg2 === void 0 ? void 0 : _this$errorMsg2.image;
        return {
          backgroundImage: "url('".concat(this.image || errorImage, "')")
        };
      },
      emptyStyle: function emptyStyle() {
        return {
          height: "100".concat(this.isFullScreen ? 'vh' : '%')
        };
      },
      errorMsg: function errorMsg() {
        return this.type && _errorMap.ERROR_MAP[this.type];
      }
    },
    methods: {
      $_imgClick: function $_imgClick() {
        if (this.type === 'unstable') {
          this.$emit('retry');
        }
      },
      $_retry: function $_retry() {
        this.$emit('retry');
      }
    }
  };
  _exports.default = _default2;
});